<div class='sso-login'>
  <div *ngIf='localeSocialAuths' class='sso-social-items'>
    <ng-container *ngFor='let socialAuth of localeSocialAuths'>
      <div *ngIf='socialAuth.display.toLowerCase() === "true"' class='sso-social-item'>
        <button (click)='clickSocialAuth(socialAuth.providerId)'>
          <img [src]='socialAuth.icon' class='sso-social-icon' [alt]='socialAuth.label' aria-hidden='true'/>
          <div class='sso-social-title'>{{socialAuth.label}}</div>
        </button>
      </div>
    </ng-container>
  </div>
  <div class='sso-alternative'>
      <p><span>{{localeTexts?.main?.or}}</span></p>
  </div>
  <form [formGroup]="loginForm" (ngSubmit)='onSubmit()'>
    <div *ngIf='errorMessage' class='sso-error-message' role="alert">
      <mat-icon aria-hidden='true'>error</mat-icon>
      <div>{{errorMessage}}
        <a *ngIf='errorShowResetPasswordLink' (click)='clickForgotPassword($event)' href='#'>
          {{localeTexts?.errors?.userResetPassword}}
        </a>
        <ng-container *ngIf='errorCustomerSupportLocked'>
          <a [href]='localeTexts?.errors?.customerSupportLinkUrl' target='_blank'>
              {{localeTexts?.errors?.customerSupportLink}}
          </a>
          {{localeTexts?.errors?.customerSupportLinkEndLocked}}
        </ng-container>
        <ng-container *ngIf='errorCustomerSupportInactive'>
          <a [href]='localeTexts?.errors?.customerSupportLinkUrl' target='_blank'>
            {{localeTexts?.errors?.customerSupportLink}}
          </a>
          {{localeTexts?.errors?.userInactiveCombinedEnd}}
        </ng-container>
        <ng-container *ngIf='errorShowActivatedLink'>
          <a (click)='sendActivationLink($event)' href='#'>
            {{localeTexts?.errors?.userNotActivatedLink}}
          </a>
          {{localeTexts?.errors?.userNotActivatedEnd}}
        </ng-container>
        <ng-container *ngIf='errorInvalidCredentialsTermindated'>
          <a (click)='clickForgotPassword($event)' href='#'>
            {{localeTexts?.errors?.userResetPassword}}
          </a>
          {{errorMessageEnd}}
        </ng-container>
      </div>
    </div>

    <div>
      <aa-input
        [id]="'sso-login-email-input'"
        [labelText]="localeTexts?.main?.email"
        formControlName="email"
        [type]="'email'"
        [form]="loginForm"
        [autocomplete]="'email'"
        [maxLength]='64'
        [error]='errorEmail'
        ></aa-input>
    </div>
    <div style='margin: 10px 0;'>
      <aa-input
        [id]="'sso-login-password-input'"
        [labelText]="localeTexts?.main?.password"
        formControlName="password"
        [form]="loginForm"
        [type]="'password'"
        [autocomplete]="'current-password'"
        [maxLength]='16'
        [minLength]='8'
        [error]='errorPassword'
      ></aa-input>
    </div>
    <div>
      <a href='#' (click)='clickForgotPassword($event)'>
        {{localeTexts?.loginTab?.forgotPassword}}
      </a>
    </div>
    <button type='submit' #submitButton class='sso-button' [disabled]='isLoading'>
      <mat-spinner *ngIf='isLoading' class='white-spinner' [diameter]="22"></mat-spinner>
      <ng-container *ngIf='!isLoading'>
          {{localeTexts?.loginTab?.login}}
      </ng-container>
    </button>
  </form>
</div>